import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplaceSemicolonPipe } from 'src/app/pipes/replace-semicolon.pipe';
import { shortDescriptionPipe } from './short-description.pipe';
import { ZerofillPipe } from './zerofill.pipe';


@NgModule({
    declarations: [
        ReplaceSemicolonPipe,
        shortDescriptionPipe,
        ZerofillPipe
    ],
    imports: [ CommonModule ],
    exports: [
        ReplaceSemicolonPipe,
        shortDescriptionPipe,
        ZerofillPipe
    ],
    providers: [],
})
export class PipeModule {}